module.exports = __webpack_public_path__ + "static/media/memberGroupEditedIcon.9fda1c1f.png";